import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

export interface SnackbarMessage {
  id: number;
  message: string;
  severity: "success" | "error" | "warning" | "info";
}

interface SnackbarState {
  messages: SnackbarMessage[];
  counter: number;
}

const initialState: SnackbarState = {
  messages: [],
  counter: 0,
};

const snackbarSlice = createSlice({
  name: "snackbar",
  initialState,
  reducers: {
    /** Add a new snackbar message. severity defaults to "error". */
    addSnackbar: (
      state,
      action: PayloadAction<{ message: string; severity?: SnackbarMessage["severity"] }>,
    ) => {
      state.counter += 1;
      state.messages.push({
        id: state.counter,
        message: action.payload.message,
        severity: action.payload.severity ?? "error",
      });
    },
    /** Remove a snackbar message by id. */
    removeSnackbar: (state, action: PayloadAction<number>) => {
      state.messages = state.messages.filter((m) => m.id !== action.payload);
    },
  },
});

export const { addSnackbar, removeSnackbar } = snackbarSlice.actions;
export default snackbarSlice.reducer;
